import { FC } from 'react';
import { useGetMachineQuery } from '../../../shared/redux/machine';
import { UnavailabilityView } from '../../unavailabilityView/index';
import { LoadingSkeleton } from './loadingSkeleton';

export const UnavailabilityTab: FC<{id: string}> = ({ id }) => {
  const { data: machine, isLoading } = useGetMachineQuery(id);

  if (!machine || isLoading) return <LoadingSkeleton />;

  return (
    <div>
      <UnavailabilityView
        id={machine.internalNumber}
        currentDate={new Date()}
      />
    </div>
  );
};
